module.exports = __webpack_public_path__ + "static/media/internaship_pragram.bc9625c7.jpeg";